import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { useUploadFile } from '@tribeplatform/react-sdk/hooks';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
import { FormControl, } from '@tribeplatform/react-ui-kit/FormControl';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { T } from '../i18n';
export const AvatarInput = (props) => {
    var _a;
    const { name, picture, alt, label, helperText, error, invalid } = props;
    const { setValue, register } = useFormContext();
    const fileInputRef = useRef();
    const { loadingFile, uploadFile, loading } = useUploadFile();
    const [uploadedFile, setUploadedFile] = useState();
    const onChangeFile = e => {
        var _a;
        const file = (_a = Array.from(e.target.files)) === null || _a === void 0 ? void 0 : _a[0];
        uploadFile(file, async (uploadedImage) => {
            setUploadedFile(uploadedImage);
            setValue(name, uploadedImage.id);
        });
    };
    const avatar = loadingFile || uploadedFile || picture;
    useEffect(() => {
        register(name);
    }, []);
    return (_jsxs("div", { children: [label ? (_jsx(FormControl.Label, { htmlFor: name, children: label }, void 0)) : null, _jsxs("div", { className: clsx('hover:bg-surface-hovered rounded-full relative w-32 h-32', label && 'mt-1'), children: [_jsx(Avatar, { size: "3xl", name: alt, src: ((_a = avatar === null || avatar === void 0 ? void 0 : avatar.urls) === null || _a === void 0 ? void 0 : _a.small) || (avatar === null || avatar === void 0 ? void 0 : avatar.url) }, void 0), _jsx("input", { type: "file", className: "hidden", multiple: false, ref: fileInputRef, onChange: onChangeFile }, void 0), loading && (_jsx("div", { className: "flex items-center justify-center text-white rounded-full bg-background-backdrop absolute top-0 bottom-0 start-0 end-0", children: _jsx(SpinnerIcon, { className: "animate-spin h-7 w-7" }, void 0) }, void 0)), !loading && (_jsx("div", { onClick: () => {
                            fileInputRef.current.click();
                        }, className: "flex items-center justify-center rounded-full text-white bg-black bg-opacity-50 opacity-0 hover:opacity-100 absolute top-0 bottom-0 start-0 end-0 cursor-pointer", children: _jsx(T, { id: "Generics.Change.Verb", defaultMessage: "Change" }, void 0) }, void 0))] }, void 0), _jsx(FormControl.Meta, { ...{ helperText, error, invalid } }, void 0)] }, void 0));
};
//# sourceMappingURL=AvatarInput.js.map